import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import {useFindShareholders} from "../../../services/apis/apiSuperintendence";
import InfoOnline from "../../components/InfoOnline";
import NotPermissionComponent from "../../dashboard/NotPermissionComponent";
import {
    PaginationShareholdersInterface
} from "../../../services/interface/query/superintendence/pagination-shareholders-interface";
import CustomTable, {TypeItemTable} from "../../../components/general/CustomTable";
import {useTaxPayerStorage} from "../../../services/storage/TaxPayerStorage";
import IdentificationConsult from "../../terms-conditions/IdentificationConsult";
import {getMessageGeneric} from "../../../services/configuration/errorHandle";

export default function Shareholders() {
    const { t } = useTranslation("global") as { t: (key: string) => string };

    const person = useTaxPayerStorage(data => data.data)

    const {
        mutate: findSuperintendence,
        data: successSuperintendence,
        error: errorSuperintendence,
        isPending: loadingSuperintendence,
    } = useFindShareholders()

    const [response, setResponse] = useState<PaginationShareholdersInterface | undefined>()
    const [listElement, setListElement] = useState<TypeItemTable[] | undefined>()
    const [index, setIndex] = useState<number | undefined>(0)

    useEffect(() => {
        if ((index || index === 0) && (person?.accountant || person?.taxIdentificationNumber)) {
            findSuperintendence({
                identifier: person?.accountant ? person?.accountant : person?.taxIdentificationNumber, page: index,
                msj: t('shareholders')
            })
        }
    }, [person, index]);

    useEffect(() => {
        if (successSuperintendence) {
            setResponse(successSuperintendence)
        }
    }, [successSuperintendence]);

    useEffect(() => {
        if (response?.content && response.content.length > 0) {
            setListElement(response.content.map((item) => ({
                row: [
                    <IdentificationConsult
                        className={'text-header pl-1 font-light'}
                        identification={item.identification}
                    />,
                    item.names,
                    item.nationalityDescription,
                    item.investmentType,
                    `$${item.capital ?? '-'}`,
                    item.restriction ? 'SI' : 'NO',
                ]
            })))
        }
    }, [response]);

    return (
        <div className={'flex flex-col gap-3'}>
            <div className={'flex flex-row gap-2'}>
                <h3>{t('shareholders')}</h3>
                <InfoOnline
                    onClick={() => {
                        if ((index || index === 0) && (person?.accountant || person?.taxIdentificationNumber)) {
                            findSuperintendence({
                                identifier: person?.accountant ? person?.accountant : person?.taxIdentificationNumber, page: index,
                                msj: t('shareholders')
                            })
                        }
                    }}
                />
            </div>
            <NotPermissionComponent
                className={'min-h-[50px]'}
                title={'/pj_information/shareholders'}
                loading={loadingSuperintendence}
                error={errorSuperintendence}
                component={
                    <>
                        <CustomTable
                            pagination={true}
                            loading={loadingSuperintendence}
                            error={getMessageGeneric(errorSuperintendence, '/pj_information/administrators')}
                            header={[
                                t('identification'),
                                t('name'),
                                t('nationality'),
                                t('type-shareholder'),
                                t('capital'),
                                t('restriction'),
                            ]}
                            number={response?.number}
                            totalElements={response?.totalElements}
                            totalPages={response?.totalPages}
                            {...{listElement, setIndex}}
                        />
                    </>
                }
            />
        </div>
    )
}
